import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

interface IDoctorProps {
	branchOfficeId: string;
	doctorId: string;
}

interface IDoctorTimeProps extends IDoctorProps {
	date: string;
}

type CancelAppointmentType = {
	id: string;
	appointmentId: string;
};

type PayloadTypes = { [key: string]: any };

export const getCandidateById = async (id: string): Promise<AxiosResponse> =>
	await api.get(`/candidates/${id}`);

export const postCandidate = async (data: any): Promise<AxiosResponse> =>
	await api.post('/candidates', data);

export const putCandidate = async (
	id: string,
	data: any,
): Promise<AxiosResponse> => await api.put(`/candidates/${id}`, data);

export const getCandidate = async (): Promise<AxiosResponse> =>
	await api.get('/candidates');

export const getBranchOffices = async (): Promise<AxiosResponse> =>
	await api.get('/branch-offices');

export const getAppointmentProfiles = async (): Promise<AxiosResponse> =>
	await api.get('/candidates/appointment-profiles');

export const getCandidateBranchOffices = async (): Promise<AxiosResponse> =>
	await api.get('/branch-offices');

export async function getCsvCandidate(): Promise<AxiosResponse> {
	return await api.get(`/candidates/export`);
}

export const getDoctorsByBranchOffice = async (params: {
	branchOfficeId: string;
}): Promise<AxiosResponse> =>
	await api.get(`/doctors-schedules/doctors`, { params });

export const getAppointments = async (id: string): Promise<AxiosResponse> =>
	await api.get(`candidates/${id}/appointments`);

export const cancelAppointment = async ({
	id,
	appointmentId,
}: CancelAppointmentType): Promise<AxiosResponse> =>
	await api.patch(`candidates/${id}/appointments/${appointmentId}`);

export const postScheduleAppointment = async (
	payload: PayloadTypes,
): Promise<AxiosResponse> => await api.post(`/appointments`, payload);

export const postScheduleExam = async (
	payload: PayloadTypes,
): Promise<AxiosResponse> => await api.post(`/appointment-request`, payload);

export const getDoctorAvailableDates = async ({
	branchOfficeId,
	doctorId,
}: IDoctorProps): Promise<AxiosResponse> =>
	await api.get(
		`/doctors-schedules/${doctorId}/dates?branchOfficeId=${branchOfficeId}`,
	);

export const getDoctorAvailableTimes = async ({
	branchOfficeId,
	doctorId,
	date,
}: IDoctorTimeProps): Promise<AxiosResponse> =>
	await api.get(
		`/doctors-schedules/${doctorId}/times?branchOfficeId=${branchOfficeId}&date=${date}`,
	);

export const getBusinessNames = async (): Promise<AxiosResponse> =>
	await api.get('/candidates/business-names');

export const getUsers = async (): Promise<AxiosResponse> =>
	await api.get('/users');
